import React, { JSX, useMemo } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Box } from '@chakra-ui/react';
import { ErrorMessages, FormHeader, FullPageLoader } from 'common/components';
import { Routes } from 'config/routes';
import { useTranslations } from 'contexts/LocalizationContext';
import { useUpdateWarehouse, useWarehouse } from 'services/warehouses';
import invariant from 'tiny-invariant';

import WarehouseForm from './WarehouseForm';

const UpdateWarehouse = (): JSX.Element => {
  const { id } = useParams<{ id: string }>();
  invariant(id, 'id is not set within the route');
  const navigate = useNavigate();
  const translations = useTranslations();
  const { data: restaurant, isLoading: isLoadingWarehouse, error: loadError } = useWarehouse(id);

  const { mutate: updateWarehouse, isLoading: isSavingWarehouse, error: updateWarehouseError } = useUpdateWarehouse();

  const formValues = useMemo(() => {
    if (restaurant) {
      return { ...restaurant, country: restaurant.address?.city?.country ?? null };
    }
    return undefined;
  }, [restaurant]);

  if (isLoadingWarehouse) {
    return (
      <FullPageLoader show>
        <Box h={100} />
      </FullPageLoader>
    );
  }

  return (
    <>
      <FormHeader>{translations('warehouses_update_header')}</FormHeader>
      <ErrorMessages errors={[updateWarehouseError, loadError]} />
      <WarehouseForm
        isLoading={isSavingWarehouse}
        onSubmit={(updateWarehouseRequest) =>
          updateWarehouse(
            { id, updateWarehouseRequest },
            {
              onSuccess: async () => navigate(Routes.WAREHOUSES_PATH),
            },
          )
        }
        formValues={formValues}
      />
    </>
  );
};

export default UpdateWarehouse;
